var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderReceipt',{attrs:{"header":"แก้ไขข้อมูลใบส่งคืนสินค้า(CN)","img_header":_vm.header_image,"link_back":"stock/storage/addproducttostock"}}),_c('StorageCN_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }